import $ from 'jquery';
import Alert from 'src/alert';
import AxlesCanvas from 'src/vehicle/chassis/axles_canvas';
import AxlesLoads from 'src/vehicle/chassis/axles_loads';
import { parseUnit, format } from 'src/utils/units_format';

export default class FederalBridgeFormula {
  constructor(options = {}) {
    this._vehicle = App.vehicles.filter(vehicle => vehicle.id === options.vehicleId)[0];

    const $vehicleConfigurationContainer = $('#fbf-vehicle-configuration');
    const $axlesConfigurationContainer   = $('#fbf-axles-configuration');
    const $resultContainer               = $('#fbf-result');

    $(document).on('change', '[data-type~=length]', event => {
      const $el = $(event.target);
      const valueFeet = parseUnit($el.val());

      $el.val(format.FT.to.FT.IN.DEC(3)(valueFeet));

      this.indicateInputsChanged();

      this.vehicle.data.spacing = $('[data-type~=length]').serializeArray().map(el => el.value);

      this.broadastEvent('axlesSpacingsChanged');
    });

    $(document).on('change', '[data-type~=weight]', event => {
      const $el = $(event.target);

      this.indicateInputsChanged();

      const weight = this.normalizeWeightInput($el);

      if (!$el.is('[data-behavior~=total-weight]')) { return; }

      if (!this.vehicle.axlesLoads) {
        this.vehicle.data.totalWeight = weight;
        return;
      }

      if (this.vehicle.axlesLoads.setTotalWeight(weight)) {
        $resultContainer.html('');
      }
    });

    $vehicleConfigurationContainer.on('submit', 'form', event => {
      event.preventDefault();

      const $form = $(event.target);

      $.ajax({
        type: 'GET',
        url:  $form.attr('action'),
        data: $form.serialize(),
        success: xhr => {
          const $submitButton = $form.find('input[type=submit]');

          $submitButton.attr('disabled', false);
          $submitButton.val('Try another vehicle');

          $resultContainer.html('');
          $axlesConfigurationContainer.html(xhr.meta.html);

          this.vehicle.data.numberOfAxles = xhr.meta.number_of_axles;
          this.vehicle.data.spacing       = xhr.meta.axles_spacings;
          this.vehicle.data.loads         = xhr.meta.axles_loads;
          this.vehicle.data.defaultLoads  = xhr.meta.axles_loads;
          this.vehicle.data.totalWeight   = this.parseWeight($vehicleConfigurationContainer.find('[data-behavior~=total-weight]').val());

          this.vehicle.axlesLoads  = new AxlesLoads({ vehicleId: this.vehicle.id });
          this.vehicle.axlesCanvas = new AxlesCanvas({ vehicleId: this.vehicle.id, trailerOrHelper: false });
        },
        error: xhr => {
          $form.find('input[type=submit]').attr('disabled', false);
          Alert.show(JSON.parse(xhr.responseText).error, 'danger');
        }
      });
    });

    $axlesConfigurationContainer.on('submit', 'form', event => {
      const $form = $(event.target);
      this.handleAxlesConfigurationSubmit(event, $form);
    });

    $axlesConfigurationContainer.on('click', 'input[type=submit]', event => {
      if (this.validateAxlesConfigurationForm(event.target.form)) { return; }

      event.preventDefault();
      event.stopImmediatePropagation();
    });
  }

  get vehicle() {
    return this._vehicle
  }

  broadastEvent(type) {
    const event = new CustomEvent(type, {
      'detail': {
        'vehicleId': this.vehicle.id
      }
    });

    document.dispatchEvent(event);
  }

  handleAxlesConfigurationSubmit(event, $form) {
    if (!this.validateAxlesConfigurationForm($form[0])) {
      event.preventDefault();
      return false;
    }

    event.preventDefault();

    const $resultContainer = $('#fbf-result');

    return $.ajax({
      type: 'POST',
      url:  $form.attr('action'),
      data: $form.serialize(),
      success(xhr) {
        const $submitButton = $form.find('input[type=submit]');

        $submitButton.attr('disabled', false);
        $submitButton.removeClass('btn-primary');
        $submitButton.addClass('btn-default');

        $resultContainer.html(xhr);
      },
      error(xhr) {
        $form.find('input[type=submit]').attr('disabled', false);
        Alert.show(JSON.parse(xhr.responseText).error, 'danger');
      }
    });
  }

  indicateInputsChanged() {
    $('form#federal-bridge-formula input[type=submit]').removeClass('btn-default');
    $('form#federal-bridge-formula input[type=submit]').addClass('btn-primary');
  }

  parseWeight(weightStr) {
    return weightStr.match(/(kg|kilo|kilgram|kilogramm|killogramm|kilo)s?/) ?
      Math.round(weightStr.replace(/\D/g, '') * 2.2)
    :
      Number(weightStr.replace(/\D/g, ''));
  }

  formatWeight(weight) {
    return `${weight.toLocaleString()} lbs`;
  }

  normalizeWeightInput($el) {
    const weight = this.parseWeight($el.val());
    $el.val(this.formatWeight(weight));
    return weight;
  }

  validateAxlesConfigurationForm(form) {
    if (!form || form.reportValidity()) { return true; }

    Alert.show('Please fill in all required axle configuration fields before continuing.', 'danger');
    return false;
  }
};
